import { render } from "./OpeningStock.vue?vue&type=template&id=200a55e1"
import script from "./OpeningStock.vue?vue&type=script&lang=js"
export * from "./OpeningStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__